
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[id]",
      function () {
        return require("private-next-pages/help/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[id]"])
      });
    }
  